export const LOGIN = 'LOGIN';
export const RESET_SUCCESS = 'RESET_SUCCESS';
export const SUCCESS_LOGIN = 'SUCCESS_LOGIN';
export const LOGOUT = 'LOGOUT';
export const SUCCESS = 'SUCCESS';

export const ERROR = 'ERROR';
export const GET_MESSAGE = 'GET_MESSAGE';
export const DISMISS_MESSAGE = 'DISMISS_MESSAGE';

export const CHECKING_TOKEN = 'CHECKING_TOKEN';
export const SET_TOKEN = 'SET_TOKEN';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const NO_TOKEN = 'NO_TOKEN';
export const SUCCESS_TOKEN = 'SUCCESS_TOKEN';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';

export const GET_BUSINESSES = 'GET_BUSINESSES';
export const GOT_BUSINESSES = 'GOT_BUSINESSES';

export const BUSINESSES_ERROR = 'BUSINESSES_ERROR';
export const GET_BUSINESS = 'GET_BUSINESS';
export const GOT_BUSINESS = 'GOT_BUSINESS';
export const BUSINESS_ERROR = 'BUSINESS_ERROR';

export const GOT_MY_BUSINESSES = 'GOT_MY_BUSINESSES';
export const GET_MY_BUSINESSES = 'GET_MY_BUSINESSES';
export const MY_BUSINESSES_ERROR = 'MY_BUSINESSES_ERROR';
export const MY_BUSINESSES_PAGE = 'GET_MY_BUSINESSES_PAGE';

export const DELETING_BUSINESS = 'DELETING_BUSINESS';
export const DELETE_ERROR = 'DELETE_ERROR';
export const BUSINESS_DELETED = 'BUSINESS_DELETED';

export const REGISTER_BUSINESS = 'REGISTER_BUSINESS';
export const REGISTER_BUSINESS_SUCCESS = 'REGISTER_BUSINESS_SUCCESS';
export const REGISTER_BUSINESS_ERROR = 'REGISTER_BUSINESS_ERROR';
export const DISMISS_BUSINESS_MESSAGE = 'DISMISS_BUSINESS_MESSAGE';

export const UPDATE_BUSINESS = 'UPDATE_BUSINESS';
export const UPDATE_BUSINESS_SUCCESS = 'UPDATE_BUSINESS_SUCCESS';
export const UPDATE_BUSINESS_ERROR = 'UPDATE_BUSINESS_ERROR';
export const DISMISS_UPDATE_BUSINESS_MESSAGE =
  'DISMISS_UPDATE_BUSINESS_MESSAGE';

export const EDIT_BUSINESS = 'EDIT_BUSINESS';
export const CANCEL_EDIT_BUSINESS = 'CANCEL_EDIT_BUSINESS';

export const ADD_REVIEW = 'ADD_REVIEW';
export const ADD_REVIEW_FAIL = 'ADD_REVIEW_FAIL';
export const ADD_REVIEW_SUCCESS = 'ADD_REVIEW_SUCCESS';
export const ADDED_REVIEW = 'ADDED_REVIEW';

// SEARCH BUSINESS 

export const SEARCH_BUSINESS = 'SEARCH_BUSINESS';
export const SEARCH_BUSINESS_RESULT = 'SEARCH_BUSINESS_RESULT';
export const SEARCH_BUSINESS_ERROR = 'SEARCH_BUSINESS_ERROR';



// WEBPACK FOOTER //
// ./src/actions/Constants.js